<template>
	<div >
		<b-card no-body>
			<h5>{{title}}</h5>
			<hr>
			<b-table sticky-header
		        ref="refUserListTable"
		        class="position-relative"
		        :items="items"
		        responsive
		        :fields="tableColumns"
		        show-empty
		        empty-text="No matching records found"
		      >

		      	<template #cell(device_name)="items">
	            	<!-- <p class="wordBreak">{{ items.item.device_name | capitalize}}</p> -->
                <b-link
                    v-b-tooltip.hover.v-warning
                    variant="outline-warning"
                    :to="{ name: 'device-stats', params: { id: items.item._id, device_name: items.item.device_name, device_type: items.item.device_type, device_id: items.item.device_id, site: items.item.site, color: graphColor(items.item.percentage, items.item.device_type, items.item.device_status)} }"
                    v-if="items.item.device_type != 'Toilet Roll Sensor' && items.item.device_type != 'Hand Soap Dispenser Sensor' && items.item.device_type != 'Trash Bin Sensor' && items.item.device_type != 'Other'"
                >
                  {{ items.item.device_name | capitalize}}
                </b-link>

                <b-link
                    v-b-tooltip.hover.v-warning
                    variant="outline-warning"
                    :to="{ name: 'sensor-stats', params: { device_id: items.item._id, sensor_id: items.item.device_id, sensor_name: items.item.device_name, sensor_type: items.item.device_type, color: graphColor(items.item.percentage, items.item.device_type, items.item.device_status)} }"
                    v-if="items.item.device_type == 'Toilet Roll Sensor' || items.item.device_type == 'Hand Soap Dispenser Sensor' || items.item.device_type == 'Trash Bin Sensor' || items.item.device_type == 'Other'"
                >
                  {{ items.item.device_name | capitalize}}
                </b-link>
	        	</template>
		      	
            <template #cell(last_updated)="items">
	            	<p v-if="items.item.last_updated != 'N/A'" class="wordBreak">
                  {{ items.item.last_updated | dateRangePicker}}
                  <br>
                  {{ items.item.last_updated | timeHM}}
                </p>
                <p v-else>N/A</p>
	        	</template>
	        
		        <template #cell(value)="items">
		           
		            <span v-if="items.item.device_type == 'Toilet Roll Sensor' || items.item.device_type == 'Hand Soap Dispenser Sensor' || items.item.device_type == 'Trash Bin Sensor' || items.item.device_type == 'Other'">
                  <span v-if="items.item.percentage < 0 || items.item.percentage > 100"> - </span>
                  <span v-else>{{ items.item.percentage ? Math.round(items.item.percentage) + '%' : '0%'}}</span>
                </span>
                    
                <span v-else-if="items.item.device_status == 'Online' && (items.item.device_type == 'Ammonia Sensor' || items.item.device_type == 'Traffic Counter Sensor')">
                  {{ items.item.current_value ? items.item.current_value : '0'}}
                </span>
                <span v-else-if="items.item.device_status == 'Offline' && (items.item.device_type == 'Ammonia Sensor' || items.item.device_type == 'Traffic Counter Sensor')">
                  {{ items.item.current_value ? items.item.current_value : '0'}}
                </span>

                <span v-else-if="(items.item.device_type == 'Wetness Floor Sensor')">{{ items.item.wet | capitalize}}</span>
                <span v-else-if="(items.item.device_type == 'Cubicle Occupancy Detection')">{{ items.item.door_status | capitalize}}</span>

                <span v-else-if="(items.item.device_type == 'Temperature & Humidity Sensor')">T - {{items.item.current_value}} <br> H - {{items.item.current_humidity}}</span>

                <!-- <span v-if="items.item.max_people_count">
                    {{items.item.max_people_count}}
                </span>

                <span v-if="items.item.max_ammonia_value">
                    {{items.item.max_ammonia_value}}
                </span> -->
		         
		        </template>


		        <template #cell(device_status)="items">

                <p v-if="items.item.device_status == 'Error'">
                    <b-badge pill variant="info" class="text-capitalize w-100">
                            Error
                    </b-badge>
                </p>
                <p v-if="items.item.device_status == 'Empty'">
                    <b-badge pill :variant="items.item.device_type == 'Trash Bin Sensor' ? 'success' : 'danger'" class="text-capitalize w-100">
                            Empty
                    </b-badge>
                </p>
                <p v-if="items.item.device_status == 'Low'">
                    <b-badge pill variant="warning" class="text-capitalize w-100">
                            Low
                    </b-badge>
                </p>
                <p v-if="items.item.device_status == 'Mid'">
                    <b-badge pill style="background: #D4AF37;" class="text-capitalize w-100">
                            Mid
                    </b-badge>
                </p>
                <p v-if="items.item.device_status == 'Full'">
                    <b-badge pill :variant="items.item.device_type == 'Trash Bin Sensor' ? 'danger' : 'success'" class="text-capitalize w-100">
                            Full
                    </b-badge>
                </p>
                <p v-if="items.item.device_status == 'Offline'">
                    <b-badge pill variant="danger" class="text-capitalize w-100">
                            Offline
                    </b-badge>
                </p>
                <p v-if="items.item.device_status == 'Online'">
                    <b-badge pill variant="success" class="text-capitalize w-100">
                            Online
                    </b-badge>
                </p>

            </template>

            <template #cell(actions)="items">

                <b-link
                    
                    v-b-tooltip.hover.v-warning
                    title="View Stats"
                    variant="outline-warning"
                    :to="{ name: 'device-stats', params: { id: items.item._id, device_name: items.item.device_name, device_type: items.item.device_type, device_id: items.item.device_id, site: items.item.site, color: graphColor(items.item.percentage, items.item.device_type, items.item.device_status)} }"
                    v-if="items.item.device_type != 'Toilet Roll Sensor' && items.item.device_type != 'Hand Soap Dispenser Sensor' && items.item.device_type != 'Trash Bin Sensor' && items.item.device_type != 'Other'"
                >
                  <feather-icon icon="EyeIcon" class="mr-1 smallSize"/>
                </b-link>

                <b-link
                    
                    v-b-tooltip.hover.v-warning
                    title="View Stats"
                    variant="outline-warning"
                    :to="{ name: 'sensor-stats', params: { device_id: items.item._id, sensor_id: items.item.device_id, sensor_name: items.item.device_name, sensor_type: items.item.device_type, color: graphColor(items.item.percentage, items.item.device_type, items.item.device_status)} }"
                    v-if="items.item.device_type == 'Toilet Roll Sensor' || items.item.device_type == 'Hand Soap Dispenser Sensor' || items.item.device_type == 'Trash Bin Sensor' || items.item.device_type == 'Other'"
                >
                  <feather-icon icon="EyeIcon" class="mr-1 smallSize"/>
                </b-link>


            </template>

		  	</b-table>
		</b-card>

	</div>
  <!-- <div v-else>
    <h5>No Data Found</h5>
  </div> -->
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,VBTooltip
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { POST_API_SUCCESS } from "../../../store/actions.type"
import Bus from "../../../event-bus";

export default {
  props: ['title','building','level', 'location'],
  components: {

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    VBTooltip,
    vSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
    
  },
  data() {
    return {
       tableColumns: [
            { key: 'device_id', label: 'Id', sortable: false , thStyle:  {width: '5%'}},
            { key: 'device_name', label: 'Sensor', sortable: false , thStyle:  {width: '35%'}},
            { key: 'value', label: 'Current Value', sortable: false , thStyle:  {width: '20%'}},
            { key: 'device_status', label: 'Status', sortable: false , thStyle:  {width: '10%'}},
            { key: 'last_updated', label: 'Last Updated', sortable: false , thStyle:  {width: '25%'}},
            // { key: 'actions', label: '', sortable: false , thStyle:  {width: '5%'}},
          ],
        
        items:[],
    }
  },
  methods : {
    graphColor(percentage, device_type, status){
      if(device_type == 'Trash Bin Sensor' || device_type == 'Hand Soap Dispenser Sensor' || device_type == 'Toilet Roll Sensor'){
        if(percentage < 0 || percentage > 100){
          return '00cfe8';
        }
        if(percentage >= 0 && percentage <= 15){
          return device_type == 'Trash Bin Sensor' ? '28c76f' : 'ea5455';
        }
        if(percentage > 15 && percentage <= 30){
          return 'ff9f43';
        }
        if(percentage > 30 && percentage <= 75){
          return 'D4AF37';
        }
        if(percentage > 75){
          return device_type == 'Trash Bin Sensor' ? 'ea5455' : '28c76f';
        }
      }
      else if(status == 'Offline'){
        return 'ea5455';
      } 
      else if(status == 'Online'){
        return '28c76f';
      }
    },

  	dataList(){
        return this.$store.dispatch(POST_API_SUCCESS, {
            data:{
                building    : this.building._id,
                level      	: this.level,
                location : this.location,
            },
            api: '/api/device-overview-toilet-type'
        })
        .then(() => {
            if (this.$store.getters.containsErrors) {
                this.error_message = this.$store.getters.getErrors;
            } else {
            	this.items = [];

                this.items          = this.$store.getters.getResults.data;
                return this.items;
            }
        });
    },
    
  }, 
  mounted(){
    this.dataList();

    // update overview emit
    Bus.$on('update-overview', () => {
      this.dataList();
    })
    
    Bus.$on('update-sensor-report', () => {
      this.dataList();
    })
  }
  
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>